document.addEventListener('DOMContentLoaded', () => {
  // Testimonial Slider
  $('.testimonial-slider').slick({
    dots: false,
    nav:true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 3000
  });
  $(".prev-btn").click(function () {
		$(".testimonial-slider").slick("slickPrev");
	});

	$(".next-btn").click(function () {
		$(".testimonial-slider").slick("slickNext");
	});
	$(".prev-btn").addClass("slick-disabled");
	$(".testimonial-slider").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prev-btn").addClass("slick-disabled");
		} else {
			$(".prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".next-btn").addClass("slick-disabled");
		} else {
			$(".next-btn").removeClass("slick-disabled");
		}
	});
  
  // announcement-bar
  //   $('.announcement_slides').slick({
  //   dots: false,
  //   nav:true,
  //   slidesToShow: 1,
  //  slidesToScroll: 1,
  //   infinite: true,
  //   speed: 500,
  //   fade: true,
  //     dots:false,
  //     arrows:false,
  //   cssEase: 'linear',
  //   autoplay: true,
  //   autoplaySpeed: 3000
  // });



    $('.as_seen_on_sec ul.multicolumn-list').slick({
    dots: false,
    nav:true,
    slidesToShow: 6,
   slidesToScroll: 1,
    infinite: true,
    speed: 500,
      dots:false,
      arrows:false,
    cssEase: 'ease',
    autoplay: true,
    autoplaySpeed: 3000,
      responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
     {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
     {
      breakpoint: 479,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
      
  });
  
  // details on hover

$(window).resize(function(){  /*Bind an event handler to the "resize"*/
  if ($(window).width() < 990) {
     

$(function() {
  $('header details').on('mouseover', function() {
    $(this).attr('open', true);
  }).on('mouseout', function() {
    $(this).attr('open', false);
  })
});
        }
});
});


 $('.customer_feedback_slider').slick({
    dots: false,
    nav:false,
    slidesToShow: 3,
   slidesToScroll: 1,
    infinite: true,
    speed: 500,
      dots:false,
      arrows:true,
    cssEase: 'ease',
    autoplay: true,
    autoplaySpeed: 3000,
      responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
     {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
     
  ],
      
  });
